

















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class TableDeleteButton extends Vue {
  @Prop({ type: Boolean, default: false })
  disabled!: boolean;
}
